import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { HandleError } from '../../utils/handler-error';
import { Reward } from './reward';
import { RewardCategory } from './reward-category';

@Injectable({ providedIn: 'root' })
export class RewardService {
  constructor(private http: HttpClient) { }

  public createReward(reward: Reward): Observable<Reward> {
    return this.http.post<Reward>(`${environment.API}/reward`, reward)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public getRewards(): Observable<Reward[]> {
    return this.http.get<Reward[]>(`${environment.API}/reward`)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public updateReward(reward: Reward): Observable<Reward> {
    return this.http.put<Reward>(`${environment.API}/reward`, reward)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public getCategories(): Observable<RewardCategory[]> {
    return this.http.get<RewardCategory[]>(`${environment.API}/reward/categories`)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }
}
